import { render, staticRenderFns } from "./IndicatorsDrawer.vue?vue&type=template&id=4927d522&scoped=true"
import script from "./IndicatorsDrawer.vue?vue&type=script&lang=js"
export * from "./IndicatorsDrawer.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsDrawer.vue?vue&type=style&index=0&id=4927d522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927d522",
  null
  
)

export default component.exports